import { createFileRoute } from '@tanstack/react-router';
import { PageShell, Spinner } from '@viquard/doc-ui';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { useMe } from '@/features/auth/api';
import { MemberProfilePage } from '@/features/members/components';

function ProfileRoute(): ReactNode {
  return (
    <AuthGuard>
      <CurrentUserProfile />
    </AuthGuard>
  );
}

function CurrentUserProfile(): ReactNode {
  const me = useMe();
  const userId = me.data?.user.id;
  if (userId === undefined) {
    return (
      <PageShell className="members-page members-page--loading" role="status" aria-live="polite">
        <Spinner size="md" />
      </PageShell>
    );
  }
  return <MemberProfilePage userId={userId} />;
}

export const Route = createFileRoute('/profile')({
  component: ProfileRoute,
});
